export const input_data = {
  music: {
    rows: [

      {
        artist_name: "Mary J. Blige",
        song_name: "No one",
        genre: "R&B",
        album_name: "The Breakthrough",
        record_company: "Geffen Records",
        id: 100
      },
      {
        artist_name: "2Pac",
        song_name: "All Eyez on Me",
        genre: "",
        album_name: "All Eyez on me",
        record_company: "Death Row Records",
        id: 101
      },
      {
        artist_name: "Aaliyah",
        song_name: "Try Again",
        genre: "R&B, Soul",
        album_name: "Romeo Must Die",
        record_company: "Sound on Sound Studios",
        id: 102
      },
      {
        artist_name: "Mary J. Blige",
        song_name: "No one",
        genre: "R&B, Soul",
        album_name: "The Breakthrough",
        record_company: "Geffen Records",
        id: 103
      },
      {
        artist_name: "Cold Play",
        song_name: "Clocks",
        genre: "Alternative Rock",
        album_name: "A Rush of Blood to the Head",
        record_company: "Parlophone",
        id: 104
      },
      {
        artist_name: "Michael Jackson",
        song_name: "Man in the Mirror",
        genre: "Pop, Soul",
        album_name: "Bad 25",
        record_company: "Epic",
        id: 105
      },
      {
        artist_name: "Cold Play",
        song_name: "clocks",
        genre: "",
        album_name: "Rush of Blood to the Head",
        record_company: "Parlophone",
        id: 106
      },
      {
        artist_name: "Michael Jackson",
        song_name: "Thriller",
        genre: "Pop",
        album_name: "Thriller",
        record_company: "Epic",
        id: 107
      },
      {
        artist_name: "Michael Jackson",
        song_name: "Billie Jean",
        genre: "Post-disco, rhythm and blues",
        album_name: "",
        record_company: "Epic",
        id: 108
      }
    ],
    columns: [
      {name: "artist_name", title: "Artist Name"},
      {name: "song_name", title: "Song Name"},
      {name: "genre", title: "Genre"},
      {name: "album_name", title: "Album Name"},
      {name: "record_company", title: "Record Company"}
    ]
  },
  electronics: {
    rows: [
      {
        name: "panasonic black 8.5 ' portable dvd player dvdls83",
        description:
          "panasonic black 8.5 ' portable dvd player dvdls83 8.5 ' free style wide screen lcd display 6 hour battery multi format playback dual headphone jacks divx playback car dc adapter included black finish",
        price: "",
        id: 1
      },
      {
        name: "sony bravia theater black micro system davis50b",
        description:
          "8.5 ' lcd dvd + rw , dvd-rw , dvd-ram , dvd + r , dvd-r , cd-rw dvd video , cd-da , mp3 , jpeg , mpeg-4 , divx , wma , video cd , svcd , highmat playback",
        price: "$148.69",
        id: 2
      },
      {
        name: "sony bdp-s550 blu-ray dvd player",
        description: "",
        price: "$322.7",
        id: 3
      },
      {
        name: "sony cyber-shot black digital camera dsch10b",
        description:
          "sony dsch10 cyber-shot black digital camera dsch10b 8.1 megapixels 3.0 ' lcd display carl zeiss 10x optical zoom lens 31 mb internal memory versatile flash advanced sports mode 9-point auto focus high sensitivity mode burst mode face detection in-camera retouching super steadyshot optical image stabilization with anti-blur solution music slideshow hdtv compatibility stamina battery power beginner-friendly function guide black finish",
        price: "$237",
        id: 4
      },
      {
        name: "sony blu-ray disc player bdps550",
        description:
          "sony blu-ray disc player bdps550 decode dolby truehd and dts hd internally full hd 1080 video output 24p true cinema dvd upscaling to 1080p via hdmi bravia theatre sync ( hdmi-cec ) bd/dvd/cd playback and avchd with x.v. color output dolby digital plus decoding backlit remote glass front finish",
        price: "",
        id: 5
      },
      {
        name: "sony cyber-shot dsc-h10 digital camera black dsch10/b",
        description:
          "8.1 megapixel 1`6:9 2x digital zoom 3 ' active matrix tft color lcd",
        price: "$213.72",
        id: 6
      },
      {
        name: "canon silver powershot digital camera sd880is",
        description:
          "canon silver powershot digital camera sd880is 10 megapixel 4x optical zoom optical image stabilizer 3.0 ' purecolor lcd ii digic 4 image processor face detection self-timer red-eye correction 19 shooting modes print/share button silver finish",
        price: "",
        id: 7
      },
      {
        name: "samsung 50 ' widescreen plasma hdtv pn50a650",
        description:
          "samsung 50 ' widescreen plasma hdtv pn50a650 touch of color ultra filterbright anti glare technology 1,000,000:1 dynamic contrast ratio picture-in-picture anti-burn-in technology sports/game/movie modes single integrated user interface with wheel-key remote atsc/ntsc/clear qa tuners",
        price: "",
        id: 8
      }
    ],
    columns: [
      {name: "name", title: "Name"},
      {name: "description", title: "Description"},
      {name: "price", title: "Price"}
    ]
  }
};
